import { VStack } from '@cad-arc';
import { ReactElement } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { SearchResultsExportsFooter } from './search-results-exports-footer';
import { SearchResultsFooter } from './search-results-footer';
import { ResultSelectionStore } from './use-observable-search-results-selection-store';
import { PaginationContextType } from './use-pagination';
import { SearchResultsContent } from './search-results-content';
import { FileExportHandlerType } from '../event-search/types';

interface SearchResultsProps {
    header: ReactElement;
    searchQuery: UseQueryResult<unknown>;
    executeSavedSearchQuery: UseQueryResult<unknown>;
    selection?: ResultSelectionStore;
    pagination: PaginationContextType;
    onFileExport?: FileExportHandlerType;
    isExportLoading?: boolean;
    isCSVExportLoading?: boolean;
    isEventSearch?: boolean;
    children?: ReactElement;
    results?: unknown[];
    allowConsolidatedExport?: boolean;
}

export function SearchResults({
    header,
    children,
    searchQuery,
    executeSavedSearchQuery,
    results,
    selection,
    pagination,
    onFileExport,
    isExportLoading,
    isCSVExportLoading,
    isEventSearch,
    allowConsolidatedExport,
}: SearchResultsProps) {
    const isInitialLoading =
        searchQuery.isInitialLoading ?? executeSavedSearchQuery.isInitialLoading;
    const isError = searchQuery.isError ?? executeSavedSearchQuery.isError;
    const isNoResults = !!results && results.length === 0;
    const hasResults = !!results && results.length > 0;
    const showExportsFooter =
        results && selection?.anySelected && onFileExport && isExportLoading !== undefined;

    return (
        <VStack align="left" h={isInitialLoading || isNoResults || isError ? '100%' : undefined}>
            {header}
            <SearchResultsContent
                isError={isError}
                isNoResults={isNoResults}
                isInitialLoading={isInitialLoading}
            >
                {children}
            </SearchResultsContent>
            {showExportsFooter && (
                <SearchResultsExportsFooter
                    allowConsolidatedExport={allowConsolidatedExport}
                    selection={selection}
                    totalCount={pagination.totalItemCount}
                    isEventSearch={isEventSearch}
                    onFileExport={onFileExport}
                    isExportLoading={isExportLoading}
                    isCSVExportLoading={isCSVExportLoading}
                />
            )}
            {(isInitialLoading || hasResults) && (
                <SearchResultsFooter pagination={pagination} results={results} />
            )}
        </VStack>
    );
}
